module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?> <svg version=1.2 baseProfile=tiny id=points xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 55.5 13\" xml:space=preserve> <g> <circle class=cls-6 fill=#c8c8c8 cx=6.5 cy=6.5 r=6.5 /> <circle class=cls-6 fill=#c8c8c8 cx=27.8 cy=6.5 r=6.5 /> <circle class=cls-6 fill=#c8c8c8 cx=49 cy=6.5 r=6.5 /> </g> </svg> ";


//////////////////
// WEBPACK FOOTER
// ./public/web/images/3tochki.svg
// module id = fVYj
// module chunks = 3 4